<template>
  <div class="how-earn-root" :class="[packageName]">
    <div class="how-title">{{ $t('lang.newInvite.k005') }}</div>
    <div class="how-block">
      <p>{{ $t('lang.newInvite.k006') }}</p>
      <div class="content-wrap">
        <div class="invite-btn" @click="handleClick">{{ $t('lang.newInvite.k001') }}</div>
      </div>
    </div>
    <div class="connect-arrow">
      <img src="../images/double-down.png" alt="" />
    </div>
    <div class="how-block">
      <!-- 多包判断 -->
      <!-- You earn #color-purple:120 #img:beans when your friends complete verification and call -->
      <MyPLabel v-if="packageName === 'kiko'" :str="$t('lang.newInvite.k007')" :numsOption="[{ value: info.maxInviteBeanReward || '', style: 'color:#ff8a33' }]" />
      <MyPLabel v-else :str="$t('lang.newInvite.k007')" :numsOption="[{ value: info.maxInviteBeanReward || '', style: 'color:#a338fc' }]" />
      <div class="content-wrap">
        <div class="step-tips1">
          <div class="tips-item">
            <img src="../images/status-step1.png" alt="" />
          </div>
          <div class="tips-item add-icon">
            <img src="../images/add.png" alt="" />
          </div>
          <div class="tips-item">
            <img v-if="packageName === 'kiko'" src="../images/status-step2-kiko.png" alt="" />
            <img v-else src="../images/status-step2.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="connect-arrow">
      <img src="../images/double-down.png" alt="" />
    </div>
    <div class="how-block">
      <!-- <p>You will get up <i class="color-purple">30%</i> weekly commission when your friends earn</p> -->
      <MyPLabel :str="$t('lang.newInvite.k008')" :numsOption="[{ value: `${info.maxShareRate || ''}%`, style: 'color:#a338fc' }]" />
      <div class="content-wrap">
        <div class="step-tips1">
          <div class="tips-item">
            <img v-if="packageName === 'kiko'" src="../images/status-step2-kiko.png" alt="" />
            <img v-else src="../images/status-step2.png" alt="" />
          </div>
          <div class="tips-item add-icon">
            <img src="../images/add.png" alt="" />
          </div>
          <div class="tips-item">
            <img v-if="packageName === 'kiko'" src="../images/msg-kiko.png" alt="" />
            <img v-else src="../images/msg.png" alt="" />
          </div>
          <div class="tips-item add-icon">
            <img src="../images/add.png" alt="" />
          </div>
          <div class="tips-item">
            <img src="../images/gift.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HowtoEarn',
  props: {
    info: {
      type: Object,
      default: () => {
        return undefined
      }
    }
  },
  methods: {
    handleClick() {
      this.$emit('action')
    }
  }
}
</script>
<style lang="scss" scoped>
.how-earn-root {
  box-sizing: border-box;
  width: 100%;
  padding-bottom: 20px;
  background-color: #f1f1fc;
  overflow: hidden;
  .how-title {
    font-family: RobotoFlex-Regular;
    font-weight: bold;
    font-size: 20px;
    color: #333333;
    width: 100%;
    text-align: center;
    margin: 32px 0 16px;
  }

  .how-block {
    width: 343px;
    height: 160px;
    margin: 0 auto;
    background: #ffffff;
    border-radius: 8px;
    padding: 12px;
    p {
      font-family: RobotoFlex-Regular;
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      line-height: 22px;
    }
    .content-wrap {
      width: 319px;
      height: 84px;
      background: #f8f8ff;
      border-radius: 4px;
      margin: 8px auto 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .invite-btn {
        width: 192px;
        height: 44px;
        background: linear-gradient(90deg, #fff76c 0%, #ffc855 8%, #ffc956 92%, #fff96a 100%);
        box-shadow: inset 0px 2px 2px 0px #fef069, inset 0px -1px 1px 0px #e18250;
        border-radius: 89px;
        font-family: RobotoFlex-Regular;
        font-weight: bolder;
        font-size: 17px;
        color: #39156f;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .step-tips1 {
        width: 284px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .tips-item {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 24px;
            height: 24px;
          }
        }
        .add-icon {
          width: 36px;
          height: 36px;
          background: transparent;
          img {
            width: 20px;
            height: 20px;
          }
        }
      }

      .step-tips2 {
        width: 257px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-around;
        img {
          width: 24px;
          height: 24px;
        }
      }
    }
  }

  .connect-arrow {
    width: 100%;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 32px;
      height: 32px;
    }
  }

  .beans-img {
    width: 20px;
    height: 20px;
    vertical-align: text-top;
  }
}

.how-earn-root.kiko {
  box-sizing: border-box;
  width: 100%;
  padding-bottom: 20px;
  background-color: #f1f1fc;
  overflow: hidden;
  .how-title {
    font-family: RobotoFlex-Regular;
    font-weight: bold;
    font-size: 20px;
    color: #333333;
    width: 100%;
    text-align: center;
    margin: 32px 0 16px;
  }

  .how-block {
    width: 343px;
    height: 160px;
    margin: 0 auto;
    background: #ffffff;
    border-radius: 8px;
    padding: 12px;
    p {
      font-family: RobotoFlex-Regular;
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      line-height: 22px;
    }
    .content-wrap {
      width: 319px;
      height: 84px;
      background: #f8f8ff;
      border-radius: 4px;
      margin: 8px auto 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .invite-btn {
        width: 192px;
        height: 44px;
        background: linear-gradient(90deg, #fff76c 0%, #ffc855 8%, #ffc956 92%, #fff96a 100%);
        box-shadow: inset 0px 2px 2px 0px #fef069, inset 0px -1px 1px 0px #e18250;
        border-radius: 89px;
        font-family: RobotoFlex-Regular;
        font-weight: bolder;
        font-size: 17px;
        color: #000000;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .step-tips1 {
        width: 284px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .tips-item {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 24px;
            height: 24px;
          }
        }
        .add-icon {
          width: 36px;
          height: 36px;
          background: transparent;
          img {
            width: 20px;
            height: 20px;
          }
        }
      }

      .step-tips2 {
        width: 257px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-around;
        img {
          width: 24px;
          height: 24px;
        }
      }
    }
  }

  .connect-arrow {
    width: 100%;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 32px;
      height: 32px;
    }
  }

  .beans-img {
    width: 20px;
    height: 20px;
    vertical-align: text-top;
  }
}
</style>
